<template lang="pug">
  .balance
    .toolbar
      .mobile-title
        span.mobile-title__number.semibold 06
        span Баланс количественных характеристик
      .top-header
        h1.title {{$route.meta ? $route.meta.title : '' }}
        .actions-panel.view-panel.view-panel_divide
          e-button-add(
            v-if="hasDownloadFileButton && getFileNameDownload($route.name)"
            @click="handleDownload($route.name)"
            label="Скачать приложения к ТС"
            btnDefaultClass=" "
          ).actions-panel__button.btn-text.button.button_usual
          div.actions-panel.view-panel.view-panel_divide
            button.actions-panel__button.btn-export.view-panel__button.button_export.button_icon(
              v-if="hasItems"
              :title="$translate('Экспорт')"
              @click="redirectToExport()"
            )
            e-button-add.view-panel__button.view-panel__button_add(
              @click="handleAdd"
              title="Добавить целевой показатель"
              label="Добавить"
            )
            e-year-selector(year="year" @onSelectItem='onSelectYear')
    .content.overflow-visible.max-height-initial
      .wrapper
        .table.table_balance(ref='table_balance')
          .table__header
            .table__row
              .table__col.table__head(
                v-for="field in header"
                :class="field.hasOwnProperty('children')?'table__head_with-children': getClass(field.path)"
                :style="field.hasOwnProperty('children')?`min-width:calc(130px * ${getLength(field.children)})` : ''"
              ) {{field.hasOwnProperty('children') ? '' : field.label }}
                span(v-if="field.hasOwnProperty('children')" ) {{field.label}}
                .display-flex(v-if="field.hasOwnProperty('children')" :style="`min-width:calc(130px * ${getLength(field.children)})`")
                  .table__col.table__head(
                    v-for="child in field.children"
                    :class="child.hasOwnProperty('children')?'table__head_with-children':''"
                    :style="child.hasOwnProperty('children')?`min-width:calc(130px * ${getLength(child.children)})` : ''"
                  ) {{child.hasOwnProperty('children') ? '' : child.label}}
                    span(v-if="child.hasOwnProperty('children')" ) {{child.label}}
                    .display-flex(v-if="child.hasOwnProperty('children')" :style="`min-width:calc(130px * ${getLength(child.children)})`")
                      .table__col.table__head(
                        v-for="ch in child.children"
                      ) {{ch.label}}

          .table__body
            .table__row(v-for="(item, i) in rawItems" :key="'block-'+i")
              .block-header
                .table__row(:id="i+1")
                  .table__col(
                    v-for="key in fields"
                    :class="getClass(key)"
                    )
                    span(
                      :contenteditable="!contenteditableList.includes(key) ? item.contenteditable : false"
                      v-model="item[key]"
                      :data-key="key"
                      @paste="(e) => item[key] = updateCopyValue(e)"
                      @blur="(e) => handleBlur(e, item, key)"
                      @change="(e) => handleChange(e, item, key)"
                    ) {{item[key]}}
                  .table__col.table__col_sticky
                    button.reset-btn.button.button_edit.button_small.button_icon(
                      @click.prevent="editRow(item)"
                      title="Редактировать"
                    )
                    button.button.button_save.reset-btn.button_small.button_icon(
                      @click.prevent="saveHandle(item)"
                      title="Сохранить"
                    )
                    button.button.button_delete.reset-btn.button_small.button_icon(
                      @click.prevent="deleteRow(item)"
                      title="Удалить"
                    )
          .table__row
            .block-header.block-header_name
              .block-name(:style="`width: ${tableWidth}`")
                .table__col.table__col_sticky.table__col_sticky-left Всего отходов

          .table__row(v-for="(item, i) in rawTotals.dangerClasses" :key="'block-total-'+i")
            .block-header
              .table__row
                .table__col.bold(
                  v-for="key in fields"
                  :class="getClass(key)"
                )
                  span(
                    v-model="item[key]"
                    :data-key="key"
                  ) {{item[key]}}
          .table__row
            .block-header
              .table__row
                .table__col.bold(
                  v-for="key in fields"
                  :class="getClass(key)"
                )
                  span(
                    v-model="rawTotals.total[key]"
                    :data-key="key"
                  ) {{rawTotals.total[key]}}

    e-modal(
      v-if="showAddModal"
      modalClass="fixed-overlay fixed-overlay__modal autoHeight"
      @close="showAddModal = false"
      @confirm="saveItem"
      title="Добавление"
    )
      slot
        .add-popup
          .add-field
            label.add-field__label(for="add-field-input") Наименование*
            input.add-field__input#add-field-input(
              v-model="newItem.name"
              placeholder="Введите минимум 2 символа"
              v-debounce:300="changeNewItem"
            )
          .add-popup__error(v-if="hasFkkoError") Фкко не найдено
          ul.add-list
            li.add-list__item(
              v-for="item in addList"
              @click="selectItem(item)"
            ) {{item.name}}
</template>

<script>
import { cadastr, indicator } from '@/api/api-endpoints'
import year from '@/utils/year'
import exportMixin from '@/mixins/export-mixin'
import routeMixin from '@/mixins/route-mixin'
import { REGION_CONFIG } from '@/config/regions'
import downloadFileMixin from '@/mixins/download-file-mixin'
import hasMixin from '@/mixins/has-mixin'

const PER_PAGE = 10

export default {
  name: 'balance-line',
  mixins: [exportMixin, routeMixin, downloadFileMixin, hasMixin],
  data() {
    return {
      query: '',
      header: [],
      rawItems: [],
      rawTotals: [],
      tableWidth: '100%',
      newItem: {
        id: null,
        name: '',
        code: '',
        danger: '',
      },
      contenteditableList: [
        'number_row',
        'code',
        'name',
        'danger',
        'total',
        'processedTotal',
        'processedTotalPercent',
        'recycledAfterProcessingPercent',
        'recycledTotalAll',
        'recycledTotalAllPercent',
        'neutralizedTotal',
        'neutralizedTotalPercent',
        'burialTotal',
        'burialTotalPercent',
        'storageTotal',
        'storageTotalPercent',
      ],
      hasFkkoError: false,
      addList: [],
      tempFkko: [],
      showAddModal: false,
      hasItems: false,
      year:
        this.$route?.query?.year || REGION_CONFIG.customBalanceYear
          ? REGION_CONFIG.customBalanceYear
          : year.getCurrentYear(),
    }
  },
  computed: {
    fields() {
      const fields = []

      function countFields(obj) {
        obj.forEach((item) => {
          if (item.path) {
            fields.push(item.path)
          }
          if (item['children'] && item['children'].length) {
            countFields(item.children)
          }
        })
      }

      countFields(this.header)
      return fields
    },
    items() {
      return this.rawItems.map((item) => {
        const newItems = item.map((el) => {
          return this.addEditableAttr(el)
        })
        return {
          ...item,
          items: newItems,
        }
      })
    },
    rowData() {
      const obj = {}

      this.fields.map((item) => {
        obj[item] = 0
      })
      return obj
    },
    endpointExport() {
      const currentYear = this.year
      return indicator.fkkoExport({ query: { year: currentYear } })
    },
  },
  methods: {
    getLength(arr) {
      let length = arr.length
      arr.forEach((el) => {
        if (el.hasOwnProperty('children')) {
          el.children.forEach((el2) => {
            if (el2.hasOwnProperty('children')) {
              length = length + el2.children.length - 1
            }
          })
          length = length + el.children.length - 1
        }
      })
      return length
    },
    getClass(key) {
      const arr = ['danger', 'code', 'name', 'number_row']

      const formatWidth = arr.includes(key) ? `${key}` : ''
      const formatSticky = arr.includes(key)
        ? `table__col_sticky table__col_sticky-left`
        : ''
      const anchorField = key === 'burialTotal' ? 'anchor' : ''

      return `${formatWidth} ${formatSticky} ${anchorField}`
    },
    handleAdd() {
      this.showAddModal = true
    },
    saveItem() {
      if (!this.newItem.id) {
        this.hasFkkoError = true
        return false
      }

      const items = []
      const item = {
        ...this.rowData,
      }
      item.code = this.newItem.code.replaceAll(' ', '')
      item.name = this.newItem.name
      item.danger = this.newItem.danger
      item.fkko_id = this.newItem.id
      item.number_row = this.rawItems.length
        ? this.rawItems.at(-1).number_row + 1
        : 1
      items.push(item)

      this.rawItems.push(item)
      this.newItem.name = ''
      this.newItem.id = null
      this.showAddModal = false
    },
    editRow(item) {
      item.contenteditable = !item.contenteditable
      this.$forceUpdate()

      const elemsTable = document.getElementsByClassName('anchor')
      const currentAnchor = Array.from(elemsTable).find(
        ({ parentElement }) => +parentElement.id === item.number_row
      )
      currentAnchor.scrollIntoView({
        inline: 'start',
        behavior: 'smooth',
        block: 'nearest',
      })
    },
    deleteRow(row) {
      const fkko_id = row.fkko_id
      this.$e.confirmBox().then(async () => {
        await this.$store.dispatch('deleteModel', {
          url: indicator.fkko({
            query: { year: this.year, fkko_id },
          }),
          data: {},
        })

        this.$e.successBox('Запись удалена')
        this.getData()
      })
    },
    async saveHandle(block) {
      const deleteKeys = [
        'contenteditable',
        'number_row',
        'total',
        'processedTotal',
        'processedTotalPercent',
        'recycledAfterProcessingPercent',
        'recycledTotalAll',
        'recycledTotalAllPercent',
        'neutralizedTotal',
        'neutralizedTotalPercent',
        'burialTotal',
        'burialTotalPercent',
        'storageTotal',
        'storageTotalPercent',
      ]

      if (block.hasOwnProperty('items')) {
        block.items.map(async (el) => {
          deleteKeys.forEach((key) => delete el[key])
          return el
        })
      } else {
        deleteKeys.forEach((key) => delete block[key])
      }
      try {
        await this.$store.dispatch('createModel', {
          url: indicator.fkko(),
          data: {
            year: this.year,
            items: block?.items || [block],
          },
        })
        this.hasItems = true
        this.$e.successBox('Запись сохранена')
        this.getData()
      } catch (e) {
        const errors = Object.values(e.data.errors).join(', ')
        this.$e.errorBox(errors)
      }
    },

    setNumberRow: function (data) {
      for (const el of this.rawItems) {
        el.number_row =
          data._meta.pageCount === 1 || !data._meta.hasOwnProperty('pageCount')
            ? this.rawItems.indexOf(el) + 1
            : (data._meta.pageCount - 1) * data._meta.perPage +
              this.rawItems.indexOf(el) +
              1
      }
    },
    async getData() {
      this.year = this.$route?.query?.year || this.year
      const data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: indicator.fkko({ query: { year: this.year } }),
        })
      ).data
      const { indicatorsFkko, totals } = data.data
      this.rawItems = indicatorsFkko
      this.rawTotals = totals
      this.rawTotals.total.name = 'Всего:'
      this.rawTotals.dangerClasses.forEach((el, key) => (el.danger = key))

      this.header = data._meta.fields
      this.header.unshift({ path: 'number_row', label: '№ п/п' })
      this.header.push({ label: '' })
      this.hasItems = !!this.rawItems.length

      this.setNumberRow(data)
    },

    async changeNewItem(val) {
      this.hasFkkoError = false
      if (val.length < 2) {
        this.addList = []
        return false
      }
      this.addList = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: cadastr.fkko({
            query: {
              q: val,
              'per-page': PER_PAGE,
              sort: 'code',
              has_danger_only: 0,
            },
          }),
        })
      ).data.data
    },
    addEditableAttr(item) {
      return {
        ...item,
        contenteditable: false,
      }
    },
    selectItem(item) {
      this.newItem = {
        id: item.id,
        name: item.name,
        code: item.code,
        danger: item.danger,
      }
      this.addList = []
    },
    updateCopyValue(e) {
      const value = e.clipboardData.getData('text/plain')
      const newValue = value.replace(/,/g, '.')
      e.currentTarget.blur()
      e.currentTarget.textContent = newValue
      return newValue
    },
    handleBlur(e, item, key) {
      const value = e.currentTarget.textContent
      item[key] = value.replace(/,/g, '.')
      this.$forceUpdate()
    },
    handleChange(e, item, key) {
      const value = e.currentTarget.textContent
      const newValue = value.replace(/,/g, '.')
      e.currentTarget.textContent = newValue
      item[key] = newValue
    },
    onSelectYear(year) {
      this.replaceRoute({
        year: year,
      })
      this.getData()
    },
  },
  created() {
    this.getData().then(() => {
      this.tableWidth = `${this.$refs.table_balance.scrollWidth}px`
    })
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/utils/variables';
@import '../../assets/scss/utils/mixins';

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block {
  margin-top: -20px;
}

.main-layout {
  .content {
    .table {
      overflow-y: auto;
      max-height: calc(100vh - 166px);

      &::-webkit-scrollbar {
        height: 6px;
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        box-shadow: inset 0 0 6px rgba(170, 170, 170, 0.6);
      }

      th,
      td {
        min-width: 135px;
        max-width: 135px;
        border: 1px solid #ddd;
        border-top: none;
        border-left: none;

        &:first-child {
          border-width: 1px;
        }
      }

      td {
        &.block-header {
          padding-left: 0 !important;
        }

        &.total-item {
          font-weight: 700;

          &.last {
            min-width: 97px;
          }
        }

        [contenteditable='true'] {
          display: inline-block;
          min-width: 50px;
          padding: 5px;
          background-color: #e2e2e2;
        }

        &.block-name {
          background-color: #dae3f3;
          border-color: #dae3f3;
          text-align: center;
        }

        &:first-child {
          border-left-width: 0;

          &.block-name {
            border-color: #dae3f3;
          }
        }
      }

      table {
        border-collapse: initial;

        thead {
          position: sticky !important;
          top: 0;
          z-index: 2;
          background-color: #fff;

          th {
            text-align: center;

            &.edit-head {
              min-width: 97px;
              border-bottom: none;
              border-right: none;
            }
          }
        }

        tbody {
          transform: translateX(-2px);

          tr {
            &:last-child {
              td {
                border-bottom: none;
              }
            }

            td {
              &.block-header {
                padding: 0;
              }

              &.edit-col {
                position: sticky !important;
                right: 0;
                min-width: 97px;
                border: none;
                padding: 5px;
                background: #fff;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    position: sticky;
    bottom: 0;
    left: 0;
    background-color: #fff;
  }

  .footer-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .add-popup {
    padding: 20px;
    min-height: 200px;

    &__error {
      color: $error-color;
      margin-top: 10px;
    }
  }

  .add-field {
    &__label {
      display: inline-block;
      margin-bottom: 10px;
    }

    &__input {
      width: 100%;
    }
  }

  .add-list {
    position: relative;
    list-style-type: none;
    background-color: #fff;
    z-index: 2;
    margin: 0;
    padding: 0;
    max-height: 400px;
    max-width: 400px;
    overflow: hidden;
    overflow-y: scroll;
    @include scrollbars();

    &__item {
      padding: 10px;
      border: 1px solid #e2e2e2;
      cursor: pointer;

      &:first-child {
        border-top: none;
      }

      &:not(:last-child) {
        border-bottom: none;
      }
    }
  }
}

.table__head,
.table__col {
  &.danger,
  &.number_row {
    word-break: break-all;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  &.number_row {
    min-width: 40px !important;
  }

  &.danger {
    min-width: 60px !important;
  }
  &.name {
    min-width: 300px;
  }
  &.code {
    min-width: 150px;
  }
  &_sticky {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 5px;
    padding: 5px;
    min-width: 130px;

    .button_small {
      width: 100%;
      margin-right: 0;
    }
  }
  &.bold {
    min-height: fit-content;
    &:last-child {
      min-width: 260px;
    }
  }
  & > * {
    min-height: fit-content;
  }
}

.table__col_sticky {
  background-color: #fafbfc !important;
  &-left:first-child {
    left: 0;
  }
  &-left:nth-child(2) {
    left: 40px;
  }
  &-left:nth-child(3) {
    left: 190px;
  }
  &-left:nth-child(4) {
    left: 490px;
    border-right: 5px solid $grey-true !important;
  }
}

.table__header {
  .table__row {
    .edit-head {
      display: flex;
      flex-direction: row;
      position: sticky;
      left: 0;
      min-width: 160px;
      border-bottom: 3px solid $grey-true !important;
    }
  }
}
.block-header_name {
  padding: 0;
  .block-name {
    border-color: #dae3f3;
    & > .table__col_sticky {
      border-color: #dae3f3 !important;
      background-color: #dae3f3 !important;
      padding-left: 45px;
      min-width: 152px;
    }
  }
  &.block-header {
    .block-name {
      padding: 10px 0;
      background-color: #dae3f3;
      border-color: #dae3f3;
    }
  }
}

@media screen and (max-width: $mobile-width) {
  .top-header {
    display: block;
  }
}
</style>
